module.exports = __webpack_public_path__ + "static/img/success_form.31e8ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success_form.png
// module id = n1iL
// module chunks = 1